import { Target, Heart, Users, Globe, Clock } from 'lucide-react';
import about from "../assets/ChatGPT.png"
import { MECCA_TO_CHRIST_NAME, MECCA_TO_CHRIST_URL } from '../data/ministry';

function About() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <img src={about} alt='img' className='img-about'/>
           {/* <div className="text-8xl mb-6">🕌</div> */}
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            About <span className='text-yellow-600'>Mecca Prayer House</span>
          </h1>
          <p className="text-xl text-gray-600">
            Connecting Muslims with accurate prayer times across North America
          </p>
          <a
            href={MECCA_TO_CHRIST_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-block rounded-full border border-yellow-300 bg-yellow-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-yellow-800 transition-colors hover:border-yellow-500 hover:bg-yellow-100"
          >
            A ministry of {MECCA_TO_CHRIST_NAME}
          </a>
        </div>

        <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-2xl p-8 mb-12">
          <div className="flex items-start mb-6">
            <div className="bg-yellow-600 p-3 rounded-lg mr-4">
              <Target className="h-8 w-8 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Our Mission</h2>
                <p className="text-gray-700">
                At <span className='bg-yellow-400'>Mecca Prayer House</span>, we are a community united in prayer with a specific calling:
                 to intercede for our Muslim neighbors in the West. We see the devotion of those who 
                 faithfully turn toward Mecca, and our hearts are moved with compassion for their sincere
                 <span className='bg-yellow-400'> search for God</span> . It is our earnest mission, grounded in <span className='bg-yellow-400'>Christian love</span>, to lift them before God in prayer.
                  <span className='bg-yellow-400'>We pray</span> that their hearts, already inclined toward worship, would be divinely drawn to encounter the hope, grace, 
                  and eternal salvation found in <span className='bg-red-400'>Jesus Christ</span>. We believe prayer is the foundation of this spiritual journey, and through it,
                   we participate in God's work of <span className='bg-yellow-400'>revelation and redemption</span>.
              </p>
            </div>
          </div>
        </div>

        <div className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Story</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
            <p className="text-gray-700">
                at <span className='bg-yellow-400'>Mecca Prayer House</span> began with a simple, God-given burden: witnessing the profound spiritual hunger in our own Western cities, 
                especially within the Muslim community. We saw neighbors and friends turning with deep devotion toward Mecca, 
                and while we respected their faith, our hearts were stirred by a greater longing—that they might know the Jesus we know.
              </p>
              <p className="text-gray-700">
               What started as a small group of believers praying in living rooms has grown into a dedicated ministry of intercession. 
               We are not activists or debaters; we are pray-ers. Our story is woven from hours of quiet prayer, 
               believing that as we lift the Muslim world before God, He is faithfully drawing hearts to Himself, 
               turning sincere seekers into redeemed sons and daughters through the grace of Christ. This is our calling, 
               our passion, and our ongoing story.
              </p>
            </div>
            <div className="bg-yellow-600 rounded-2xl p-8 text-white">
              <div className="inline-flex items-center justify-center p-3 bg-white/20 rounded-full mb-4">
                <Users className="h-8 w-8" />
              </div>
              <h3 className="text-xl font-bold mb-3">Growth & Impact</h3>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <Heart className="h-5 w-5 mr-2" />
                  <span>Serving Many users monthly</span>
                </li>
                <li className="flex items-center">
                  <Globe className="h-5 w-5 mr-2" />
                  <span>Covering all 50 states + Canadian provinces</span>
                </li>
                <li className="flex items-center">
                  <Clock className="h-5 w-5 mr-2" />
                  <span>Real-time prayer time calculations</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Team</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { name: 'Dr. Ahmed Joktan', role: 'Founder' },
              { name: 'Tarek', role: 'Developer' },
              { name: 'Emily', role: 'UX Designer' },
            ].map((member, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-sm border">
                <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                  <Users className="h-8 w-8 text-yellow-400" />
                </div>
                <h4 className="font-bold text-gray-900">{member.name}</h4>
                <p className="text-yellow-400 text-sm">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;